import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'
import React, { useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { LoaderOverlay } from 'core-components/library/loader'
import { Actions } from 'core-components/library/modalDialog'

import { TRANSLATION_KEYS } from '../../../../../translations'

interface IProps {
  onCancel: () => void
  affectedLPCount: number
  onAgree: () => void
  headerTranslation: string
  textTranslation: string
}

export const AffectedLPModalContent = ({
  affectedLPCount,
  onAgree,
  onCancel,
  headerTranslation,
  textTranslation,
}: IProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const handleAgree = useCallback(async () => {
    setIsLoading(true)
    await onAgree()
    setIsLoading(false)
  }, [onAgree])

  return (
    <div>
      <LoaderOverlay show={isLoading} />
      <WidgetHeader>{headerTranslation}</WidgetHeader>

      <Translation
        text={textTranslation}
        replaceParams={[
          {
            key: '{count}',
            value: String(affectedLPCount),
          },
        ]}
      />
      <Actions
        position={'end'}
        items={[
          {
            id: 'apply',
            label: <Translation text={TRANSLATION_KEYS.affectedLPModal.agree} />,
            onClick: handleAgree,
          },
          {
            id: 'cancel',
            label: <Translation text={TRANSLATION_KEYS.affectedLPModal.cancel} />,
            onClick: onCancel,
            variant: 'text',
            color: 'grey',
          },
        ]}
      />
    </div>
  )
}
